import loadable from '@loadable/component';
import FullPageLoading from '../../components/Loading/FullPageLoading';
import { THERAPIST_ROUTES_PREFIX } from '../therapist-planning/therapist-planning.path';

export const THERAPIST_INVITE_PATIENT_PATHNAME = `${THERAPIST_ROUTES_PREFIX}/invite`;

export const InvitePatientLoadable = loadable(async () => import('./invite-patient.view'), {
  fallback: <FullPageLoading />,
});
